import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { WarningIcon } from 'components/account/jobs-v2/Icons/Warning';
import { StatusColors } from 'components/account/jobs-v2/utils';
const boxStyle = {
    alignItems: 'center',
    border: '1px solid',
    borderRadius: '6px',
    display: 'flex',
    gap: '10px',
    marginBottom: '15px',
    maxWidth: '700px',
    padding: '12px 16px'
};
export const NameLinkageWarning = () => {
    const { tokens } = useContext(ThemeContext).theme;
    return (React.createElement(Box, { role: "status", style: {
            ...boxStyle,
            backgroundColor: tokens.colors.lightYellow,
            borderColor: StatusColors.Warning
        } },
        React.createElement(WarningIcon, { size: 20 }),
        React.createElement(Text, null,
            React.createElement("span", { style: { fontWeight: tokens.text.weight.bold } }, "Name Linkage Failure:"),
            ' ',
            "none of the submitted information links to the name.")));
};
// Neutral color: the account threshold isn't on the job, so pass/fail can't be shown here.
export const LikelihoodGenuineScore = ({ score }) => {
    const { tokens } = useContext(ThemeContext).theme;
    const bold = { fontWeight: tokens.text.weight.bold };
    return (React.createElement(Box, { style: { ...boxStyle, borderColor: tokens.colors.gray100 } },
        React.createElement(Text, { style: bold }, "Likelihood Genuine:"),
        React.createElement(Text, { style: bold },
            Math.trunc(score * 100),
            "%")));
};
